import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { templateBuilderMutations } from "@/features/template-builder/mutations";
import { templateBuilderQueries } from "@/features/template-builder/queries";
import { applyCachedTemplateStepOrder } from "@/features/template-builder/queries/cache";

export function useMoveStep(templateId: string) {
  const queryClient = useQueryClient();
  const { data: sections } = useQuery(templateBuilderQueries.steps(templateId));

  return useMutation({
    mutationFn: (params: { id: string; direction: "up" | "down" }) => {
      const index =
        sections?.findIndex((section) => section.id === params.id) ?? -1;
      const destinationIndex =
        params.direction === "up" ? index - 1 : index + 1;
      const current = sections?.[index];
      const destination = sections?.[destinationIndex];
      if (
        !current ||
        !destination ||
        current.isReadOnly ||
        destination.isReadOnly
      ) {
        throw new Error("Section cannot be moved in that direction");
      }

      return templateBuilderMutations.moveTemplateStep({
        templateId,
        stepId: current.id,
        analysisOrder: destination.order,
      });
    },
    onSuccess: ({ steps }) => {
      applyCachedTemplateStepOrder(queryClient, templateId, steps);
    },
  });
}
